import { Box, Button, HStack, Icon, Tag, Text, VStack } from '@chakra-ui/react';
import { LuBot, LuUsersRound } from 'react-icons/lu';

import { TAgent } from '@/types/agents';

interface AgentCardProps {
  agent: TAgent;
  onOpenDetails: () => void;
}

const AgentCard = ({ agent, onOpenDetails }: AgentCardProps) => {
  return (
    <Box
      borderRadius={12}
      bg="white"
      p={4}
      onClick={onOpenDetails}
      cursor="pointer"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      transition="all 0.2s ease"
      _hover={{
        boxShadow: '0 0 4px 0 rgba(24, 24, 27, 0.30), 0 4px 8px 0 rgba(24, 24, 27, 0.10)',
      }}
      boxShadow="0 0 1px 0 rgba(24, 24, 27, 0.30), 0 4px 8px 0 rgba(24, 24, 27, 0.10)"
    >
      <VStack align="stretch" justify="space-between" gap={3} mb={3}>
        <HStack gap={3} align="center">
          <Box position="relative">
            <Icon as={LuBot} color="purple.600" boxSize={8} />
          </Box>

          <Text
            fontWeight={700}
            fontSize={16}
            color="gray.700"
            lineHeight="24px"
            flex={1}
          >
            {agent.name}
          </Text>
        </HStack>

        <Text
          fontSize={14}
          color="fg.muted"
          fontWeight={400}
          lineHeight="20px"
        >
          {agent.description}
        </Text>

        <HStack>
          <Tag.Root
            size="xl"
            backgroundColor="gray.100"
            borderRadius="full"
            px={3}
            py={1}
          >
            <Tag.Label display="flex" alignItems="center" gap={2}>
              <Icon as={LuUsersRound} color="gray.600" boxSize={4} />
              <Text fontSize="sm" color="gray.600" fontWeight={400}>
                {`Assigned to ${agent.assignCustomers.length} customer(s)`}
              </Text>
            </Tag.Label>
          </Tag.Root>
        </HStack>
      </VStack>

      <Box>
        <Box
          height="1px"
          borderTop="1px dashed"
          borderColor="gray.300"
          width="100%"
          mb={3}
        />

        <HStack justify="space-between" align="center">
          <Button
            size="sm"
            variant="outline"
            colorPalette="purple"
            borderColor="purple.200"
            color="purple.600"
            borderRadius={6}
            px={4}
            py={2}
            onClick={onOpenDetails}
            _hover={{
              backgroundColor: 'purple.50',
            }}
          >
            Open Details
          </Button>
          <Text
            fontSize={12}
            color="fg.muted"
            fontWeight={400}
          >
            Click to view credentials & test
          </Text>
        </HStack>
      </Box>
    </Box>
  );
};

export default AgentCard;
